import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, Form } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CpMarketplaceApiService } from 'appRootPath/services/cp-marketplace-api.service';
import { COMMON_MESSAGES } from 'appRootPath/messages';
import {
  DOCUMENT_NAME_MAP,
  BSE_ANNEXURE_A,
  BSE_ANNEXURE_B_FURTHER,
  API_DATE_FORMAT,
  NSE_ANNEXURE_A,
  NSE_ANNEXURE_B_FURTHER
} from '../global-meta-data';
import { getDateFromCalendarObj, getCalendarDateObj, isWeekendAndHolidayDisabled } from 'appRootPath/utils';
import * as moment from 'moment';

const docKeyToExtradataDocMap = {
  [BSE_ANNEXURE_A]: 'bse_annexure_a_form_a_listing',
  [NSE_ANNEXURE_A]: 'nse_annexure_a_form_a_listing',
  [NSE_ANNEXURE_B_FURTHER]: 'nse_annexure_b_further_listing',
  [BSE_ANNEXURE_B_FURTHER]: 'bse_annexure_b_further_listing'
};
@Component({
  selector: 'app-listing-extradata-modal',
  templateUrl: './listing-extradata-modal.component.html',
  styleUrls: ['./listing-extradata-modal.component.scss']
})
export class ListingExtradataModalComponent implements OnInit {

  issueListingDataForm: FormGroup;
  scripCodeForm: FormGroup;
  BSEInput = false;
  NSEInput = false;
  isFormInvalid = false;
  documentNames = DOCUMENT_NAME_MAP;
  isWeekendAndHolidayDisabled = isWeekendAndHolidayDisabled;

  @Input() documentKey;
  @Input() listingId;
  @Input() listedIssues;
  @Input() extraDocData;
  @Input() listingDate;

  fileTypes: any = ['.pdf'];
  constructor(
    private listingDataFB: FormBuilder,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private apiService: CpMarketplaceApiService
  ) {

  }

  ngOnInit() {
    if (this.documentKey === BSE_ANNEXURE_A || this.documentKey === NSE_ANNEXURE_A) {
      this.issueListingDataForm = this.listingDataFB.group({
        listed_issues: this.listingDataFB.array([
          ...this.listedIssues.map(issue => this.createSingleListFg(issue))
        ])
      });
    }

    if (this.documentKey === BSE_ANNEXURE_B_FURTHER) {
      this.BSEInput=true
      this.scripCodeForm = this.listingDataFB.group({
        under_scrip_code_bse: [null, Validators.required]
      });
    } else if (this.documentKey === NSE_ANNEXURE_B_FURTHER) {
      this.NSEInput=true
      this.scripCodeForm = this.listingDataFB.group({
        under_scrip_code_nse: [null, Validators.required]
      });
    }

  }

  createSingleListFg(issue) {
    const oldListingData = this.extraDocData.find(extradata => Object.keys(extradata)[0] === issue.id);
    const openingDate = this.getCalendarField(issue.id, oldListingData, 'issue_opening_date');
    const closingDate = this.getCalendarField(issue.id, oldListingData, 'issue_closing_date');

    return this.listingDataFB.group({
      isin: issue.isin,
      id: issue.id,
      issue_cap: [{ value: issue.issue_cap || null, disabled: true }],
      opening_date: [openingDate, Validators.required],
      closing_date: [closingDate, Validators.required],
      max_date: getCalendarDateObj(moment(issue.value_date).toDate()),
      min_date: getCalendarDateObj(moment(issue.value_date).subtract(14, 'days').toDate())
    });
  }

  getCalendarField(issueId, oldListingData, fieldName) {
    let calendarField = null;
    const oldDate = oldListingData && oldListingData[issueId] && oldListingData[issueId][fieldName];
    if (oldDate) {
      calendarField = {};
      calendarField.year = parseInt(oldDate.split('-')[0], 10);
      calendarField.month = parseInt(oldDate.split('-')[1], 10);
      calendarField.day = parseInt(oldDate.split('-')[2], 10);
    }
    return calendarField;
  }

  postListingExtraData() {
    let formToSave: FormGroup;
    let apiRequest = {};
    let errorMsg = '';
    let successMsg = '';

    if (this.documentKey === BSE_ANNEXURE_A || this.documentKey === NSE_ANNEXURE_A) {
      formToSave = this.issueListingDataForm;
      formToSave.value.listed_issues.forEach((issue) => {
        apiRequest[issue.id] = {};
        apiRequest[issue.id].issue_opening_date = getDateFromCalendarObj(issue.opening_date).format(API_DATE_FORMAT);
        apiRequest[issue.id].issue_closing_date = getDateFromCalendarObj(issue.closing_date).format(API_DATE_FORMAT);
      });

      errorMsg = COMMON_MESSAGES.LISTING_OPENING_CLOSING_DATE_REQUIRED;
      successMsg = COMMON_MESSAGES.LISTING_ISSUE_DATA_SAVED;
    }

    if (this.documentKey === BSE_ANNEXURE_B_FURTHER || this.documentKey === NSE_ANNEXURE_B_FURTHER) {
      formToSave = this.scripCodeForm;
      apiRequest = formToSave.value;
      errorMsg = COMMON_MESSAGES.SCRIP_CODE_REQUIRED;
      successMsg = COMMON_MESSAGES.SCRIP_CODE_SAVED;
    }

    if (formToSave.invalid) {
      this.toastr.warning(errorMsg);
      this.isFormInvalid = true;
    } else {
      this.isFormInvalid = false;

      this.apiService.saveListingExtraData(
        this.listingId, docKeyToExtradataDocMap[this.documentKey], apiRequest)
        .subscribe((res: any) => {
          if (!res.error) {
            this.toastr.success(successMsg);
            this.activeModal.close(apiRequest);
          }
        });
    }
  }

}
